import { head, propEq } from 'ramda'
import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { formatDateRangeLabel, genRelativeDateValues } from '../../../../utils/helpers/date'
import {
  getPerspectiveOptions,
  useSelectedPerspective
} from '../../../../containers/screens/widgets/_shared/PerspectiveDropdown'
import { useGenericState } from '../../../../packages/kiti/components/helpers/GenericState'
import DateFilter from '../../../../components/filter/DateFilter'
import IconText from '../../../../packages/kiti/components/presentation/IconText'

const PeriodFilter = () => {
  const { t } = useTranslation('common')
  const value = useFilterValue('date')
  const label = formatDateRangeLabel(value || [])

  const handleChangeFilter = useChangeFilterValue()
  const { handleChange: handleChangePerspective } = useGenericState()
  const perspective = useSelectedPerspective()

  return (
    <DateFilter
      label={label}
      field="date"
      onChange={value => {
        if (!value) return
        let relativeDate = genRelativeDateValues(value)
        const perspectiveOptions = getPerspectiveOptions(relativeDate, t)
        handleChangeFilter('date', relativeDate)
        handleChangePerspective(
          'perspective',
          perspectiveOptions.find(propEq('id', perspective.id)) || head(perspectiveOptions)
        )
      }}
      Link={({ label, onClick }) => (
        <IconText iconRight="RiCalendarEventLine" iconSize={1.2} color="dark3" bold label={label} onClick={onClick} />
      )}
    />
  )
}

export default PeriodFilter
